<template>
  <div class="root-box">
    <el-tabs v-model="tab" @tab-click="query">
      <el-tab-pane label="新结算" name="ref4">
        <settlement-summary />
      </el-tab-pane>
      <el-tab-pane label="新流水" name="ref5">
        <settlement-detail />
      </el-tab-pane>
      <el-tab-pane label="渠道" name="ref3">
        <type-analysis />
      </el-tab-pane>
      <el-tab-pane label="服务排名" name="ref6">
        <eva-rank />
      </el-tab-pane>
      <el-tab-pane label="经营" name="operate" lazy>
        <operate-analysis />
      </el-tab-pane>
      <el-tab-pane label="每日流水" name="ref7">
        <bill-detail />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import TypeAnalysis from "./TypeAnalysis";
import EvaRank from "./EvaRank";
import BillDetail from "./BillDetail";
import OperateAnalysis from "./Operate";
import SettlementSummary from "./SettlementSummary";
import SettlementDetail from "./SettlementDetail";

export default {
  components: {
    TypeAnalysis,
    EvaRank,
    BillDetail,
    OperateAnalysis,
    SettlementSummary,
    SettlementDetail
  },
  props: {},
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  data() {
    return {
      tab: "ref4"
    };
  },
  methods: {
    query() {}
  }
};
</script>
<style lang="less" scoped></style>
